import './App.css';
import { Box, Divider, Typography, } from '@mui/material';
import { createContext } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home'
import Experience from './pages/Experience';

export const ColorModeContext = createContext({ 
    toggleColorMode: () => {}, 
    mode: 'light'
});

const App = () => {
  return (
   <BrowserRouter>
        <Box sx={{ margin: { xs: '2px 5% 20px', sm: '10px 5% 20px', md: '30px 10% 20px', lg: '30px 20% 20px' } }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/experience" element={<Experience />} />
        
          </Routes>
          <Divider sx={{ width: '100%'}} />
          <Typography variant='body2' color="textSecondary" align='center' sx={{ mt: 2 }}>
            © 2025 Lee Arianne. All rights reserved.
          </Typography>
        </Box>
         
      </BrowserRouter>
  );
}

export default App;
